document.addEventListener("DOMContentLoaded", function () {
  const blocks = document.querySelectorAll(".accordion");

  blocks.forEach((block) => {
    initializeAccordion(block);
  });
});

document.addEventListener("blockEditorInit", function (event) {
  const block = event.detail.block;

  if (!block) {
    return;
  }

  if (block.matches && block.matches(".accordion")) {
    initializeAccordion(block);
  }

  block.querySelectorAll(".accordion").forEach((accordionBlock) => {
    initializeAccordion(accordionBlock);
  });
});

function initializeAccordion(blockElement) {
  const items = Array.from(
    blockElement.querySelectorAll("[data-accordion-item]"),
  );

  if (
    items.length === 0 ||
    blockElement.dataset.accordionInitialized === "true"
  ) {
    return;
  }

  blockElement.dataset.accordionInitialized = "true";

  const triggers = items
    .map((item) => item.querySelector("[data-accordion-trigger]"))
    .filter(Boolean);
  const prefersReducedMotion =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const isEditorContext =
    document.body.classList.contains("block-editor-page") ||
    window.location.pathname.includes("/wp-admin/");
  let openIndex = items.findIndex((item) => item.classList.contains("is-open"));

  if (openIndex < 0) {
    openIndex = 0;
  }

  blockElement.__accordionInteractionToken =
    blockElement.__accordionInteractionToken || 0;

  const cleanupPanelTransition = (panel) => {
    if (!panel || !panel.__accordionTransitionCleanup) {
      return;
    }

    panel.__accordionTransitionCleanup();
    panel.__accordionTransitionCleanup = null;
  };

  const cleanupContentReveal = (panelInner) => {
    if (!panelInner || !panelInner.__accordionRevealTimeout) {
      return;
    }

    window.clearTimeout(panelInner.__accordionRevealTimeout);
    panelInner.__accordionRevealTimeout = null;
  };

  const getPanelNaturalHeight = (panel) => {
    if (!panel) {
      return 0;
    }

    const previousHeight = panel.style.height;

    panel.style.height = "auto";
    const naturalHeight = panel.getBoundingClientRect().height;
    panel.style.height = previousHeight;

    return naturalHeight;
  };

  const waitForLayoutSettle = () =>
    new Promise((resolve) => {
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(resolve);
      });
    });

  const refreshGlobalAos = (delay = 0) => {
    if (!window.AOS) {
      return;
    }

    if (blockElement.__accordionAosRefreshTimeout) {
      window.clearTimeout(blockElement.__accordionAosRefreshTimeout);
      blockElement.__accordionAosRefreshTimeout = null;
    }

    blockElement.__accordionAosRefreshTimeout = window.setTimeout(() => {
      if (typeof window.AOS.refreshHard === "function") {
        window.AOS.refreshHard();
      } else if (typeof window.AOS.refresh === "function") {
        window.AOS.refresh();
      }

      blockElement.__accordionAosRefreshTimeout = null;
    }, delay);
  };

  const scrollItemIntoPosition = (item) => {
    if (!item || isEditorContext) {
      return 0;
    }

    const header = document.querySelector("header");
    const headerHeight = header ? header.offsetHeight : 0;
    const trigger = item.querySelector("[data-accordion-trigger]") || item;
    const triggerRect = trigger.getBoundingClientRect();
    const viewportTopBoundary = headerHeight + 24;
    const viewportBottomBoundary = window.innerHeight - 24;
    const isTriggerFullyVisible =
      triggerRect.top >= viewportTopBoundary &&
      triggerRect.bottom <= viewportBottomBoundary;

    if (isTriggerFullyVisible) {
      return 0;
    }

    const targetPosition = Math.max(
      0,
      window.scrollY + triggerRect.top - headerHeight - 24,
    );

    if (Math.abs(window.scrollY - targetPosition) < 12) {
      return 0;
    }

    if (window.lenis) {
      if (prefersReducedMotion) {
        window.scrollTo({
          top: targetPosition,
          behavior: "auto",
        });
      } else {
        window.lenis.scrollTo(targetPosition, { duration: 1.05 });
      }
      return prefersReducedMotion ? 0 : 1050;
    }

    if (!prefersReducedMotion && typeof gsap !== "undefined") {
      gsap.to(window, {
        duration: 1.05,
        scrollTo: { y: targetPosition, autoKill: false },
        ease: "power2.out",
      });
      return 1050;
    }

    window.scrollTo({
      top: targetPosition,
      behavior: prefersReducedMotion ? "auto" : "smooth",
    });

    return prefersReducedMotion ? 0 : 1050;
  };

  const setPanelState = (panel, expand, immediate = false) => {
    if (!panel) {
      return Promise.resolve();
    }

    cleanupPanelTransition(panel);

    const panelInner = panel.querySelector("[data-accordion-panel-inner]");
    cleanupContentReveal(panelInner);

    if (panelInner) {
      panelInner.classList.toggle(
        "is-content-visible",
        expand && (immediate || prefersReducedMotion),
      );
    }

    if (immediate || prefersReducedMotion) {
      panel.hidden = !expand;
      panel.setAttribute("aria-hidden", (!expand).toString());
      panel.style.height = expand ? "auto" : "";
      panel.style.overflow = "";
      return Promise.resolve();
    }

    const startHeight = expand ? 0 : panel.getBoundingClientRect().height;

    panel.hidden = false;
    panel.setAttribute("aria-hidden", (!expand).toString());

    const endHeight = expand ? getPanelNaturalHeight(panel) : 0;

    if (startHeight === endHeight) {
      panel.hidden = !expand;
      panel.setAttribute("aria-hidden", (!expand).toString());
      panel.style.height = expand ? "auto" : "";
      panel.style.overflow = "";

      if (expand && panelInner) {
        panelInner.classList.add("is-content-visible");
      }

      return Promise.resolve();
    }

    if (!expand && panelInner) {
      panelInner.classList.remove("is-content-visible");
    }

    panel.style.height = `${startHeight}px`;
    panel.style.overflow = "hidden";
    panel.getBoundingClientRect();

    return new Promise((resolve) => {
      let isResolved = false;

      const completeTransition = () => {
        if (isResolved) {
          return;
        }

        isResolved = true;
        panel.hidden = !expand;
        panel.setAttribute("aria-hidden", (!expand).toString());
        panel.style.height = expand ? "auto" : "";
        panel.style.overflow = "";
        resolve();
      };

      const handleTransitionEnd = (event) => {
        if (event.target !== panel || event.propertyName !== "height") {
          return;
        }

        panel.removeEventListener("transitionend", handleTransitionEnd);
        panel.__accordionTransitionCleanup = null;
        completeTransition();
      };

      panel.__accordionTransitionCleanup = () => {
        panel.removeEventListener("transitionend", handleTransitionEnd);
        panel.style.height = expand ? "auto" : "";
        panel.style.overflow = "";
        panel.__accordionTransitionCleanup = null;
        completeTransition();
      };

      panel.addEventListener("transitionend", handleTransitionEnd);

      if (expand && panelInner) {
        panelInner.__accordionRevealTimeout = window.setTimeout(() => {
          panelInner.classList.add("is-content-visible");
          panelInner.__accordionRevealTimeout = null;
        }, 140);
      }

      window.requestAnimationFrame(() => {
        panel.style.height = `${endHeight}px`;
      });
    });
  };

  const setOpenIndex = (nextIndex, immediate = false) => {
    const interactionToken = ++blockElement.__accordionInteractionToken;
    const panelTransitions = items.map((item, index) => {
      const trigger = item.querySelector("[data-accordion-trigger]");
      const panel = item.querySelector("[data-accordion-panel]");
      const shouldOpen = index === nextIndex;

      item.classList.toggle("is-open", shouldOpen);

      if (trigger) {
        trigger.setAttribute("aria-expanded", shouldOpen.toString());
      }

      return setPanelState(panel, shouldOpen, immediate);
    });

    openIndex = nextIndex;

    Promise.all(panelTransitions)
      .then(() => waitForLayoutSettle())
      .then(() => {
        if (blockElement.__accordionInteractionToken !== interactionToken) {
          return;
        }

        if (immediate) {
          refreshGlobalAos(0);
          return;
        }

        if (nextIndex < 0) {
          refreshGlobalAos(0);
          return;
        }

        const activeItem = items[nextIndex];
        const scrollDuration = scrollItemIntoPosition(activeItem);

        refreshGlobalAos(scrollDuration > 0 ? scrollDuration + 80 : 0);
      });
  };

  setOpenIndex(openIndex, true);

  triggers.forEach((trigger, index) => {
    trigger.addEventListener("click", function () {
      setOpenIndex(openIndex === index ? -1 : index);
    });

    trigger.addEventListener("keydown", function (event) {
      let nextIndex = null;

      switch (event.key) {
        case "ArrowDown":
        case "ArrowRight":
          nextIndex = (index + 1) % triggers.length;
          break;
        case "ArrowUp":
        case "ArrowLeft":
          nextIndex = (index - 1 + triggers.length) % triggers.length;
          break;
        case "Home":
          nextIndex = 0;
          break;
        case "End":
          nextIndex = triggers.length - 1;
          break;
        default:
          return;
      }

      event.preventDefault();
      triggers[nextIndex].focus();
    });
  });
}
